export default import.meta.ROLLDOWN_FILE_URL_CiFPui8A_$ZTgE8r2TbwIw